import { useShipperDeliveryProposalDetailPageProps } from "./fetch";
import { ShipperDeliveryProposalDetailPageUi } from "./ui";

type RouteParams = { deliveryProposalId: string | undefined };
export const ShipperDeliveryProposalDetailPage = (params: RouteParams) => {
  const props = useShipperDeliveryProposalDetailPageProps(
    params.deliveryProposalId,
  );
  return <ShipperDeliveryProposalDetailPageUi {...props} />;
};
